import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";
import { App } from "./App";

const BUILD_VERSION = import.meta.env.VITE_LANDING_VERSION ?? "local-dev";

// Unique build hash log so Playwright probes can verify they hit a
// fresh bundle (per CLAUDE.md UI testing rule).
console.log(
  `%c[coprocessor-landing] build=${BUILD_VERSION} hash=cl-7f3a-2026-04-28 loaded at ${new Date().toISOString()}`,
  "color: #C9A227; font-weight: bold",
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
